import { useRef, useState } from 'react';

import { getComponentFormError } from '@dec/shared';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';

export const debounce = (fn: any, delay = 250) => {
  let timeout: any;

  return (...args: any) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

interface Props {
  label: string;
  name: string;
  description?: string;
  whenChange?: (selected: any) => void;
  child?: string;
  customError?: any;
  seachFuction: any;
}

export const AutoComplete = (props: Props) => {
  const {
    formState: { errors },
    control
  } = useFormContext();
  const inputRef2 = useRef(null) as any;
  const { t } = useTranslation();

  const { label, name, description, whenChange, customError, seachFuction } = props;

  const error = getComponentFormError(name, errors);
  const [thisDefault, setDefault] = useState(undefined);

  return (
    <Form.Group>
      <Form.Label>
        {label}{' '}
        {description ? (
          <OverlayTrigger overlay={<Tooltip id={`tooltip-${name}`}>{description}</Tooltip>}>
            <span className="d-inline-block">
              <InfoCircle className="small"></InfoCircle>
            </span>
          </OverlayTrigger>
        ) : (
          <></>
        )}
      </Form.Label>
      <div className={error || customError ? 'is-invalid' : ''}>
        <Controller
          defaultValue={thisDefault}
          name={name}
          render={({ field: { onChange, value } }) => {
            return (
              <AsyncSelect
                loadingMessage={() => t('common.label.loading')}
                isClearable={true}
                value={value}
                styles={{
                  // Fixes the overlapping problem of the component
                  menu: (provided) => ({ ...provided, zIndex: 9999 })
                }}
                className="react-select"
                classNamePrefix="react-select "
                onChange={(selected: any) => {
                  onChange(selected);
                  if (whenChange) {
                    whenChange(selected);
                  }
                }}
                placeholder={''}
                noOptionsMessage={() => t('common.label.noFound')}
                loadOptions={seachFuction}
              />
            );
          }}
          control={control}
        />
      </div>

      <Form.Control.Feedback type="invalid">
        {error ? error.message : customError ? customError.message : ''}
      </Form.Control.Feedback>
    </Form.Group>
  );
};
